import { render } from "./SeoulTradeStat12Month.vue?vue&type=template&id=0c987500&ts=true"
import script from "./SeoulTradeStat12Month.vue?vue&type=script&lang=ts"
export * from "./SeoulTradeStat12Month.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__